import Cookies from 'js-cookie';
import { timeZoneCookie } from '../constants';

export function getTimeZoneFromCookie(): string | undefined {
  const tz = Cookies.get(timeZoneCookie);
  if (!tz) return undefined;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return tz;
  } catch {
    return undefined;
  }
}
